<script setup lang="ts">
interface PoemAttributes {
  NAZEV: string | null
  POPIS: string | null
  DATUMVZNIKU: Date | null
  DATUMEDITACE: Date | null
  AUTOR: string | null
  EDITOR: string | null
  PREZDIVKA: string | null
  VEK: number | null
}
const props = defineProps<{
  poemData: PoemAttributes | null
}>()

const emit = defineEmits(['close'])
</script>

<template>
  <div class="poem-window">
    <button class="close-btn" @click="emit('close')">&times;</button>

    <div class="dropdown-content" v-if="props.poemData">
      <h2 class="poem-title">{{ props.poemData.NAZEV || 'Bez názvu' }}</h2>

      <div class="poem-body">
        {{ props.poemData.POPIS || 'Zatím zde není žádný text...' }}
      </div>

      <div class="poem-author">
        Autor: <strong>{{ props.poemData.AUTOR || 'Neznámý' }}</strong>
        <span v-if="props.poemData.VEK">, {{ props.poemData.VEK }} let</span>
      </div>
    </div>

    <div class="dropdown-content" v-else>
      <p>Načítání básně...</p>
    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Newsreader:opsz,wght@6..72,400;700&display=swap');

.poem-window {
  position: absolute;
  top: clamp(60px, 6vw, 75px);
  right: clamp(1rem, 3vw, 2rem);
  width: 350px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 30px 20px 25px 20px;
  z-index: 1000;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
  color: #1a2432;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #1a2432;
  padding: 0;
  line-height: 1;
}
.close-btn:hover {
  transform: scale(1.15);
  color: #f2a900;
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  width: 100%;
}

.poem-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1a2432;
  line-height: 1.2;
  width: 100%;
  border-bottom: 2px solid #f2a900;
  padding-bottom: 8px;
}

.poem-body {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  font-family: 'Newsreader', serif;
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #2c3e50;
  background: #fdfbf7;
  padding: 15px;
  border-radius: 4px;
  box-sizing: border-box;
}

.poem-author {
  font-size: 14px;
  color: #666;
  width: 100%;
  text-align: right;
  font-style: italic;
  margin-top: 5px;
}

.poem-author strong {
  font-weight: 500;
  font-style: normal;
  color: #1a2432;
}
</style>
